import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconPoweredByProps extends SvgIconProps {}

const IconPoweredBy: React.FC<IconPoweredByProps> = ({ ...rest }) => (
  <SvgIcon viewBox="0 0 6.67 12" {...rest}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M3.33406 12H2.66739L3.33406 7.33333H1.00073C0.61406 7.33333 0.620727 7.12 0.747393 6.89333C0.87406 6.66667 0.780727 6.84 0.79406 6.81333C1.65406 5.29333 2.94739 3.02667 4.66739 0H5.33406L4.66739 4.66667H7.00073C7.32739 4.66667 7.37406 4.88667 7.31406 5.00667L7.26739 5.10667C4.64073 9.7 3.33406 12 3.33406 12Z"
      fill="#F37021"
    />
  </SvgIcon>
);

export default IconPoweredBy;
